import moment from 'moment';

export const getUnixTimeInSeconds = () => {
  return Math.floor(Date.now() / 1000);
};

export const formatUnixTimestamp = (timestamp, format) => {
  return moment.unix(timestamp).format(format);
};
